export const createReqBody = (filter, customerId) => {
  return {
    filters: {
      customerId: customerId,
      search: filter.search ? filter.search : '*',
      sentiment: filter.sentiment[0] ? filter.sentiment : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
